import React, { FC, memo } from 'react'

import { useHeaderSearch } from 'modulesCommon/serviceHooks'
import { Search } from 'components'

const SearchContainer: FC = memo(() => {
  const {
    searchHandler,
    searchResult,
    clearSearchResult,
    isGlobalHubPage,
    currentLabelCode,
    searchLoading
  } = useHeaderSearch()

  return (
    <Search
      loading={searchLoading}
      searchItems={searchHandler}
      searchResult={searchResult}
      align="right"
      className="search-header"
      clearSearchResult={clearSearchResult}
      dataTest="header-search"
      isExtended
      searchBoxIconName="magnifying-glass"
      placeHolder={
        isGlobalHubPage
          ? 'Search for project in Global Hub'
          : `Search for artists, projects, and products ${currentLabelCode ? `in ${currentLabelCode}` : ''}`
      }
    />
  )
})

export default SearchContainer
